import { render, staticRenderFns } from "./ipRecord.vue?vue&type=template&id=022ac519&scoped=true&"
import script from "./ipRecord.vue?vue&type=script&lang=js&"
export * from "./ipRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ac519",
  null
  
)

export default component.exports